module.exports = __webpack_public_path__ + "img/classicdrawing.806a7c6.webp";